module.exports = __webpack_public_path__ + "img/image11.420f9731.jpg";